import { Body, Box, ContainerProps, Divider, Select } from '@hover/blueprint';
import React, { FC } from 'react';
import BLOG_CATEGORIES from '../../../constants/blog-categories';
import { IBlogCategory } from '../../../interfaces/IBlogCategory';

interface Props extends ContainerProps {
  activeCategory: IBlogCategory;
  handleClick: Function;
}

const BlogCategoriesTabs: FC<Props> = ({
  handleClick,
  activeCategory,
  ...rest
}) => (
  <Box flexDirection="column" {...rest}>
    <Divider color="neutral.300" orientation="horizontal" opacity={1} />
    <Box
      display={{ base: 'none', tablet: 'flex' }}
      justifyContent="space-between"
      overflow="hidden"
      py={700}
      px="20px"
    >
      {BLOG_CATEGORIES.filter(item => item.key !== 'search').map(item => (
        <Body
          color={
            activeCategory?.value === item.value ? 'primary.600' : 'neutral.700'
          }
          _hover={{
            color: 'primary.600',
          }}
          cursor="pointer"
          size={500}
          textTransform="capitalize"
          onClick={() => {
            handleClick(item);
          }}
          isSemiBold
          textDecoration={
            activeCategory?.value === item.value ? 'underline' : 'none'
          }
        >
          {item.value}
        </Body>
      ))}
    </Box>
    <Box
      display={{ base: 'block', tablet: 'none' }}
      mt={500}
      mb={{ base: 500, desktop: 800 }}
    >
      <Select
        w={{ base: '100%', tablet: '276px' }}
        onChange={({ target: { value } }) => {
          handleClick(
            BLOG_CATEGORIES.find(category => category.value === value),
          );
        }}
      >
        {BLOG_CATEGORIES.filter(item => item.key !== 'search').map(category => (
          <option value={category.value} key={category.key}>
            {category.value}
          </option>
        ))}
      </Select>
    </Box>
    <Divider
      display={{ base: 'none', tablet: 'block' }}
      color="neutral.300"
      orientation="horizontal"
      opacity={1}
    />
  </Box>
);

export default BlogCategoriesTabs;
